/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 発注業務可能フラグ（月曜日）
 * @export
 * @interface EnableOrderdayMon
 */
export interface EnableOrderdayMon {
}

/**
 * Check if a given object implements the EnableOrderdayMon interface.
 */
export function instanceOfEnableOrderdayMon(value: object): value is EnableOrderdayMon {
    return true;
}

export function EnableOrderdayMonFromJSON(json: any): EnableOrderdayMon {
    return EnableOrderdayMonFromJSONTyped(json, false);
}

export function EnableOrderdayMonFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableOrderdayMon {
    return json;
}

export function EnableOrderdayMonToJSON(json: any): EnableOrderdayMon {
    return EnableOrderdayMonToJSONTyped(json, false);
}

export function EnableOrderdayMonToJSONTyped(value?: EnableOrderdayMon | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

